import React, { forwardRef, useImperativeHandle, useState, useContext } from 'react';
import { createPortal } from 'react-dom';

const DrawerContext = React.createContext();

const DrawerPortal = forwardRef(({ children, className, direction }, ref) => {
    const [isOpen, setIsOpen] = useState(false);
    const [shouldRender, setShouldRender] = useState(false);

    useImperativeHandle(ref, () => ({
        showDrawer: () => {
            setShouldRender(true);
            setTimeout(() => setIsOpen(true), 10); // Delay to allow CSS transition
        },
        hideDrawer: (e) => {
            if (e) {
                e.stopPropagation()
            }
            setIsOpen(false);
            setTimeout(() => setShouldRender(false), 300); // Match the duration of the animation
        }
    }));


    if (!shouldRender) {
        return null;
    }
    const drawerId = `drawer-${Math.random().toString(36).substring(2, 15)}`;
    const drawerDirection = direction === 'start' ? ' flex-row-reverse' : direction === 'end' ? 'drawer-end flex-row' : 'drawer-end flex-row';
    return createPortal(
        <DrawerContext.Provider value={{ hideDrawer: ref.current.hideDrawer, showDrawer: ref.current.showDrawer }}>

            <div onClick={(e) => e.stopPropagation()} className={`drawer flex ${drawerDirection} ${isOpen ? 'drawer-open backdrop-brightness-50 ' : 'drawer-close'} fixed inset-0 z-[999]`}>
                <input id={drawerId} type="checkbox" className="drawer-toggle" checked={isOpen} readOnly />
                <label onClick={ref.current.hideDrawer} className={`cursor-pointer flex-auto ${drawerDirection} ${isOpen ? ' ' : ''} `}></label>
                <div className="drawer-side">
                    <div className="menu p-4 w-80 md:w-96 min-h-full bg-base-200 text-base-content">
                        <button onClick={ref.current.hideDrawer} className='btn btn-sm btn-circle btn-ghost absolute top-4 right-4'>X</button>
                        {children}
                    </div>
                </div>
            </div>
        </DrawerContext.Provider>,
        document.body
    );
});

export default React.memo(DrawerPortal);

export const usePortalDrawer = () => useContext(DrawerContext);
